import React from 'react';

import ClockIcon from 'icons/clock.svg';
import HhqLogo from 'icons/hhq.svg';
import SimproLogoBlue from 'icons/simpro-logo-blue.svg';
import { useTranslation } from 'react-i18next';

import ProfilePhotoDisplay from 'components/application/ProfilePhotoDisplay';

import { useProjectActivityContext } from 'components/contexts/ProjectActivityContext';

import { asFormattedDateTime } from 'components/helpers/dates';
import { escapeDoubleQuotes } from 'components/helpers/strings';

export default function ActivityTableData({ history }) {
  const { isVersionPdfsEnabled } = useProjectActivityContext();

  const { t: i18nTCommon } = useTranslation('common');

  const reason = escapeDoubleQuotes(history.reason);

  const isDownloadButtonVisible = isVersionPdfsEnabled && history.versionId;

  return (
    <>
      {isVersionPdfsEnabled && (
        <td className='tw-border-grey-100 tw-font-medium tw-text-grey-900'>
          <div className='tw-flex tw-h-8 tw-items-center tw-justify-center'>
            {history.displayNumber}
          </div>
        </td>
      )}

      <td className='tw-border-grey-100'>
        <div className='handshq__cell-content--near-spaced tw-h-8'>
          <ClockIcon
            className='tw-mr-1 [&_path]:tw-fill-grey-500'
            height={20}
            width={20}
          />
          <span>{asFormattedDateTime({ date: history.createdAt })}</span>
        </div>
      </td>

      <td
        className='tw-border-grey-100'
        colSpan={isDownloadButtonVisible ? 1 : 2}
      >
        <div className='tw-flex tw-flex-wrap tw-items-center tw-justify-start'>
          <div className='tw-mr-2'>
            {history.isApiActivity ?
              <div className='tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-mint-050'>
                <span className='tw-flex tw-items-center tw-justify-center tw-align-middle tw-text-xs tw-font-semibold tw-uppercase tw-text-mint-700'>
                  {i18nTCommon('shared.api')}
                </span>
              </div>
            : history.isSimproActivity ?
              <div className='tw-flex tw-h-6 tw-w-6'>
                <SimproLogoBlue height='24px' width='24px' />
              </div>
            : history.user && !history.nadminUser ?
              <ProfilePhotoDisplay
                componentSize='xs'
                photoUrl={history.profilePhoto?.croppedUrl}
                profileInitials={`${history.user.firstName[0]}${history.user.lastName[0]}`}
              />
            : history.nadminUser && (
                <div className='tw-flex tw-h-6 tw-w-6'>
                  <HhqLogo height='24px' width='24px' />
                </div>
              )
            }
          </div>
          {history.nadminUser ?
            i18nTCommon('projects.nadminUserOnBehalfOf', {
              interpolation: { escapeValue: false },
              nadminUser: history.nadminUser,
              reason,
            })
          : reason}
        </div>
      </td>
    </>
  );
}
